export const HANDLE_SERVICES_LINK_LOADING = 'LINK_SERVICES/HANDLE_SERVICES_LINK_LOADING';